export const iconFontAwesomeHumanitarianShieldCat = (
	<i className="fa-solid fa-shield-cat"></i>
);
